/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Chats_Move_Chat_SuccessInputs */



/**
* | output |
* | --- |
* | "Chat moved successfully!" |
*
* @param {Chats_Move_Chat_SuccessInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const chats_move_chat_success = /** @type {((inputs?: Chats_Move_Chat_SuccessInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Chats_Move_Chat_SuccessInputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return /** @type {LocalizedString} */ ("Chat erfolgreich verschoben!")
	return /** @type {LocalizedString} */ ("Chat moved successfully!")
});